import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/arrow_down_grey.svg'
import _imports_1 from '../assets/arrow_up.svg'


const _withScopeId = n => (_pushScopeId("data-v-1d67f022"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "module-name" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "progress"
}
const _hoisted_4 = {
  key: 1,
  class: "progress"
}
const _hoisted_5 = { class: "pageGroupTitle" }
const _hoisted_6 = { class: "group-title" }
const _hoisted_7 = {
  type: "button",
  class: "btn",
  "aria-expanded": "false"
}
const _hoisted_8 = {
  key: 0,
  class: "group-separator"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_NavigationModal = _resolveComponent("NavigationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: group.number
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["group-item", {
        'active-item': group.click,
        'current-item': _ctx.isCurrentItem(group),
        'show-pointer': group.click,
        'locked-item': !group.click
      }]),
            onClick: ($event: any) => (_ctx.groupClick(group))
          }, [
            (group.click)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(Math.round(group.percentage) + '%'), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "align-self-center",
                    icon: ['fas', 'lock']
                  })
                ])),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.getPageGroupTitle(group, _ctx.language)), 1)
            ])
          ], 10, _hoisted_2),
          _createElementVNode("div", {
            class: _normalizeClass(["group-item mobile-navigation-button", {
        'active-item': group.click,
        'current-item': _ctx.isCurrentItem(group),
        'show-pointer': group.click,
        'locked-item': !group.click }])
          }, [
            _createElementVNode("button", _hoisted_7, [
              (!_ctx.expanded)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    id: "arrow-down-navigation-mobile",
                    class: "arrow-down-icon icon",
                    alt: "arrow-down",
                    src: _imports_0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openNavigationModal()))
                  }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    id: "arrow-right-navigation-mobile ",
                    class: "arrow-right-icon icon",
                    alt: "arrow-right",
                    src: _imports_1,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeNavigationModal()))
                  }))
            ])
          ], 2)
        ]),
        (index !== _ctx.groups.length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(["separator", { 'active-separator': _ctx.groups[index + 1].click }])
              }, null, 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isCurrentItem(group))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "pseudo-el-background active-item current-item",
              ref_for: true,
              ref: "progressBar"
            }, null, 512))
          : _createCommentVNode("", true),
        (_ctx.isCurrentItem(group))
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "pseudo-el-progress active-item current-item",
              style: _normalizeStyle({ width: Math.round(group.percentage) + '%' })
            }, null, 4))
          : _createCommentVNode("", true),
        (_ctx.isCurrentItem(group))
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "mobile-progress active-item current-item",
              ref_for: true,
              ref: "progressIndicator",
              style: _normalizeStyle({ left: _ctx.progressIndicatorOffset + 'px' })
            }, _toDisplayString(Math.round(group.percentage) + '%'), 5))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_ctx.showNavigationModal)
      ? (_openBlock(), _createBlock(_component_NavigationModal, {
          key: 0,
          showNavigationModal: _ctx.showNavigationModal,
          groups: _ctx.groups,
          language: _ctx.language,
          onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeNavigationModal())),
          onNavigateToGroup: _cache[3] || (_cache[3] = (group) => _ctx.navigateToGroup(group))
        }, null, 8, ["showNavigationModal", "groups", "language"]))
      : _createCommentVNode("", true)
  ], 64))
}